import { render } from "./AddModal.vue?vue&type=template&id=853f35be&scoped=true"
import script from "./AddModal.vue?vue&type=script&lang=js"
export * from "./AddModal.vue?vue&type=script&lang=js"

import "./AddModal.vue?vue&type=style&index=0&id=853f35be&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-853f35be"]])

export default __exports__